import React from 'react';
import {
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import Highcharts from 'highcharts';
import {
	ExploreButton,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import HighchartsReact from 'highcharts-react-official';
import { useRef } from 'react';
import { useState } from 'react';
import { renderToString } from 'react-dom/server';
import Tooltip from '../../Components/Tooltip';
import { FONTSTYLE } from 'utils/filterNames';
import { useChartContext } from 'contexts/CategoryChartContext';
import ExpandedModal from '../../Components/ExpandedModal';

const SplineColumnChart = ({
	chartTitle,
	isParent,
	chartheight,
	chartData,
}) => {
	const [isExpandedView, setIsExpandedView] = useState(false);
	const chartRef = useRef();
	const { state } = useChartContext();
	const { avgMarginBySupplierLoading } = state;

	const options = {
		chart: {
			zoomType: 'xy',
			height: chartheight,
		},
		plotOptions: {
			column: {
				animation: false,
			},
			line: {
				animation: false,
			},
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},
		xAxis: {
			categories: chartData.xAxis,
			crosshair: true,
			lineColor: colors.black,
			labels: {
				formatter: function() {
					if (typeof this.value !== 'number') {
						if (this.value === undefined) {
							return '';
						} else {
							if (this.value.length > 0) {
								return `${this.value.substring(0, 4)}...`;
							}
						}
					}
				},
				style: { ...FONTSTYLE },
			},
		},

		legend: {
			enabled: isParent ? false : true,
		},
		yAxis: [
			{
				gridLineWidth: 0,
				lineColor: colors.black,
				lineWidth: 1,
				title: {
					text: 'Gross Spend',
					style: {
						...FONTSTYLE,
						textOverflow: 'ellipsis',
					},
				},
			},
			{
				gridLineWidth: 0,
				lineColor: colors.black,
				lineWidth: 1,
				title: {
					text: 'W.Avg Margin',
					style: {
						...FONTSTYLE,
						fontSize: '9px',
						textOverflow: 'ellipsis',
					},
				},
				opposite: true,
			},
		],

		series: [
			{
				name: 'Gross Amount',
				type: 'column',
				data: chartData.columnChartData,
			},
			{
				name: 'Weighted Avg Margin',
				type: 'line',
				yAxis: 1,
				data: chartData.lineChartData,
			},
		],
		colors: ['#032E45', '#448EB4'],
		animation: false,
	};

	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
				{isParent && (
					<ExploreButton
						title="Explore"
						className="explore"
						onClick={() => setIsExpandedView(true)}
						disabled={chartData.length === 0}
					>
						<ApIcon title="Explore" material={true} iconName="find_in_page" />
					</ExploreButton>
				)}
			</Header>

			{avgMarginBySupplierLoading === true ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{chartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							<HighchartsReact
								highcharts={Highcharts}
								options={{
									...options,
									tickInterval: 1,
									tooltip: {
										shared: false,
										useHTML: true,
										backgroundColor: 'rgba(255,255,255, 0.9)',
										borderWidth: 0,
										borderRadius: 2,
										outside: true,
										formatter: function() {
											const { point } = this;
											return renderToString(
												<Tooltip
													tooltipData={point.tooltip}
													color={point.color}
												/>
											);
										},
									},
								}}
								ref={chartRef}
							/>
						</>
					)}
					{isExpandedView && (
						<ExpandedModal
							heading={chartTitle}
							show={chartData.length !== 0}
							handleClose={() => setIsExpandedView(state => !state)}
						>
							<SplineColumnChart chartheight={'30%'} chartData={chartData} />
						</ExpandedModal>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default React.memo(SplineColumnChart);
